import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TranslocoModule} from '@jsverse/transloco';
import {CoreModule} from '../../core/core.module';
import {RouterModule} from '@angular/router';
import {ReactiveFormsModule} from '@angular/forms';
import {MatTableModule} from '@angular/material/table';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatSortModule} from '@angular/material/sort';
import {MatButtonModule} from '@angular/material/button';
import {MatInputModule} from '@angular/material/input';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatDialogModule} from '@angular/material/dialog';
import {MatIconModule} from '@angular/material/icon';
import {BoxComponent} from './box.component';
import {BoxesListComponent} from './boxes-list/boxes-list.component';
import {BoxRestApiService} from './services/http/box-rest-api.service';
import {BoxResolver} from './services/resolver/box-resolver';
import {SharedModule} from '../../shared/shared.module';
import {MatSelectModule} from '@angular/material/select';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {BatchCreateBoxComponent} from './batch-create-box/batch-create-box.component';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {HealthCenterSelectDialogComponent} from './health-center-select-dialog/health-center-select-dialog.component';
import {MatBadgeModule} from '@angular/material/badge';
import {MatOptionModule} from '@angular/material/core';

@NgModule({
  declarations: [
    BoxComponent,
    BoxesListComponent,
    BatchCreateBoxComponent,
    HealthCenterSelectDialogComponent,
  ],
  imports: [
    CommonModule,
    TranslocoModule,
    RouterModule,
    ReactiveFormsModule,

    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatButtonModule,
    MatInputModule,
    MatProgressBarModule,
    MatDatepickerModule,
    MatDialogModule,
    MatIconModule,
    MatSelectModule,
    MatOptionModule,
    MatCheckboxModule,
    MatAutocompleteModule,
    MatBadgeModule,

    SharedModule,
    CoreModule,
  ],
  providers: [
    BoxRestApiService,
    BoxResolver,
  ],
})
export class BoxModule {
}
